import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import LockResetIcon from '@mui/icons-material/LockReset';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { LogoutButton } from '../../../modules/auth';
import { requestPasswordChange } from '../../../modules/auth/utils/password-change';
import { notify } from '../../../utils/notification';
const TRANS_NS = 'page-reset-password';

export const ChangePassword = () => {
  const { user } = useAuth0();
  const { t } = useTranslation(TRANS_NS);
  const [isRequested, setIsRequested] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handlePasswordChangeRequest = async () => {
    setIsLoading(true);
    const res = await requestPasswordChange(user?.email);
    setIsLoading(false);

    if (!res || res.status !== 200) {
      notify.negative({ message: t('notification.error') });
      return;
    }
    notify.positive({ message: t('notification.success') });
    setIsRequested(true);
  };

  return (
    <>
      <DialogTitle>{t('title')}</DialogTitle>
      <DialogContent sx={{ whiteSpace: 'break-spaces' }}>
        {isRequested ? (
          <Box sx={{ textAlign: 'center' }}>
            <Box display={'flex'} justifyContent={'center'} mb={2}>
              <MarkEmailReadIcon color={'primary'} sx={{ fontSize: 120 }} />
            </Box>
            <Trans
              t={t}
              i18nKey={'contentText.success'}
              values={{
                email: user?.email ?? '',
              }}
              components={{
                secondary: <Typography color={'text.secondary'} fontSize={'smaller'} />,
              }}
            />
          </Box>
        ) : (
          <Box>
            <Box display={'flex'} justifyContent={'center'} mb={2}>
              <LockResetIcon color={'primary'} sx={{ fontSize: 120 }} />
            </Box>
            <Trans
              t={t}
              i18nKey={'contentText'}
              components={{
                secondary: <Typography color={'text.secondary'} fontSize={'smaller'} />,
              }}
            />{' '}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        {isRequested ? <LogoutButton /> : null}
        {user?.email && !isRequested ? (
          <LoadingButton loading={isLoading} variant={'contained'} onClick={handlePasswordChangeRequest}>
            {t('action.submit')}
          </LoadingButton>
        ) : null}
        <Button component={Link} to={'..'}>
          {t('action.cancel')}
        </Button>
      </DialogActions>
    </>
  );
};
